import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AmlTraceHistoryItemData } from '@/redux/models';
import { navigationPages } from '@/config';
import { TraceHistoryEntry } from '../TraceHistoryEntry/TraceHistoryEntry';

import styles from './TraceHistoryItem.module.sass';

interface TraceHistoryItemProps {
  item: AmlTraceHistoryItemData;
}

const TraceHistoryItem = ({ item }: TraceHistoryItemProps): JSX.Element => {
  const navigate = useNavigate();

  const handleOpenDetails = useCallback(() => {
    navigate(navigationPages.TRACE_INVESTIGATION_DETAILS.path, {
      state: {
        uuid: item.uuid,
      },
    });
  }, [navigate, item.uuid]);

  return (
    <div className={styles.item}>
      <TraceHistoryEntry item={item} onExpand={handleOpenDetails} />
    </div>
  );
};

export default TraceHistoryItem;
